class ClientLoginUsersController {
  static controller(ROLES, $scope, $state, LoginService, authService, ProfileService, $rootScope) {
    'ngInject';

    $scope.email = $state.params.email;

    $scope.login = function(loginForm) {
      if(!loginForm.$valid){
        return;
      }

      LoginService.login($scope.email, loginForm.password.$modelValue, ROLES.client)
      .then(function(data) {

        ProfileService.getCurrentClientData().then(function(info) {
          $rootScope.accountNotActivated = info.is_activated == 'no';
          localStorage.lang = info.language.toLowerCase();
          authService.loginConfirmed({role: ROLES.client, login: data.login, password: loginForm.password.$modelValue});
          $state.go('protected.users.select-resource');
        });
        
      }, function(reason) {
        console.error('login error', reason);
        authService.loginCancelled();
        $scope.error = true;
      });
    };
  };
}

export default ClientLoginUsersController.controller;


// WEBPACK FOOTER //
// ./src/users/client/client-login.users.controller.js